import TreeViewComponent from '@components/FormFlow/ComponentsModal/Body/Content/TreeView/TreeViewComponent';
import ITreeViewItem from '@interfaces/ITreeViewItem';
import { Theme } from '@src/styled-components';
import { Row } from 'antd';
import React from 'react';
import styled from 'styled-components';

interface ITreeViewComponentPropsType {

}

interface ISelectTaskComponentStateType {
  conditionsTaskComponents: boolean;
  treeViewItems: ITreeViewItem[];
};


export default class TreeViewComponentProcess extends React.Component<ITreeViewComponentPropsType, ISelectTaskComponentStateType> {
  private treeRef: any;

  constructor(props: ITreeViewComponentPropsType) {
    super(props);
    this.state = {
      conditionsTaskComponents: true,
      treeViewItems: [],
    };

    this.treeViewUpdated = this.treeViewUpdated.bind(this);
    this.getTreeData = this.getTreeData.bind(this);
    this.validateTreeData = this.validateTreeData.bind(this);
    this.treeRef = React.createRef();

  }

  handleInputItemChange = (idx: any) => (evt: any) => {
    const newSelectList = this.state.treeViewItems.map((selectListItems, sidx) => {
      if (idx !== sidx) return selectListItems;
      return { ...selectListItems, value: evt.target.value };
    });

    this.setState({ treeViewItems: newSelectList });

  }
  handleInputScoreChange = (idx: any) => (evt: any) => {
    const newSelectListScore = this.state.treeViewItems.map((selectListScore, sidx) => {
      if (idx !== sidx) return selectListScore;
      return { ...selectListScore, weight: evt };
    });
    this.setState({ treeViewItems: newSelectListScore });
  }

  treeViewUpdated(treeViewItems: ITreeViewItem[]) {
    this.setState({ treeViewItems: treeViewItems });
  }

  validateTreeData() {
    const validateOk = this.treeRef.current.validateData();
    return validateOk;
  }

  getTreeData() {
    const data = this.treeRef.current.getTreeData();
    return data;
  }

  render() {
    return (
      <Wrapper>

        <div>
          <Row style={{ marginTop: '10px', marginLeft: '55px' }}>
            <TreeViewComponent
              data={this.state.treeViewItems}
              onChangeTree={this.treeViewUpdated}
              ref={this.treeRef}
            />
          </Row>
        </div>
      </Wrapper>
    );
  }
}
const Wrapper = styled.div`
    width:100%;
    margin-bottom: 10rem;
    .optional-validation-condition-text{
        font-weight: bold;
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .text-checkbox-validation{
        width:50%;
        margin-top: 1rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .text-input-validation{
        width: 70px;
        margin-left: 5px;
        margin-right: 5px;
        text-align: center;
    }
    .input-item-style{
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 80%;
    }
    .input-score-style{
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 100%;
    }
    .delete-style{
        margin-top: 2rem;
    }
    .count-input{
        margin-top:2px;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
    }
    .count-input-red{
        margin-top:2px;
        color: ${Theme.secondary.red};
        font-weight: bold;
    }
    @keyframes shake {
        10%, 90% {
          transform: translate3d(-1px, 0, 0);
        }
      
        20%, 80% {
          transform: translate3d(2px, 0, 0);
        }
      
        30%, 50%, 70% {
          transform: translate3d(-4px, 0, 0);
        }
      
        40%, 60% {
          transform: translate3d(4px, 0, 0);
        }
      }
      .apply-shake {
          animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
      }

`
